import { Course, File as FileModel } from '../../models'

export const handleAttachments = (
  course: Course,
  files: Array<File>,
  info: object,
  uploadHandler: Function
) => {
  try {
    files.map((file) => {
      const reader = new FileReader()

      reader.onabort = () => console.error('file reading was aborted') // TODO FIX ERROR FOR UPLOAD
      reader.onerror = () => console.error('file reading has failed') // TODO FIX ERROR FOR UPLOAD

      reader.onloadend = async () => {
        console.log(course)
        const uploadedFile = FileModel.create({
          course_id: course.id,
          step_id: course.getCurStep.id,
          uri: reader.result,
          title: file.name,
          size: file.size,
          mime_type: file.type,
        })

        await uploadedFile.upload(false)

        uploadHandler({
          result: [
            {
              name: uploadedFile.title,
              size: uploadedFile.size,
              url:
                process.env.STORAGE_URL +
                uploadedFile.key,
            },
          ],
        })
      }
      reader.readAsDataURL(file)
    })
  } catch (err) {
    uploadHandler(err.toString())
  }
}
